import * as types from '../constants/actions';
import { makeAsyncReducer, asyncDefaults, mergeReducers } from '../../../ui-lottery/src/utils/async_utils';

const fetchPassTypes = makeAsyncReducer(types.FETCH_PASS_TYPES, { initialData: [] });

const passTypes = mergeReducers(asyncDefaults([]), types.PP_PREFIX, fetchPassTypes);

export default passTypes;

export const selectors = {
  getPassTypes: (state) => state.parkpass.passTypes.data
};
